"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALARM_STATUS_COLORS = void 0;
var ALARM_STATUS_COLORS = {
    ACTIVE: "red",
    ACKNOWLEDGED: "blue",
    RESOLVED: "green-soft",
};
exports.ALARM_STATUS_COLORS = ALARM_STATUS_COLORS;
